import './Subiecte.css';

export default function Subiecte2022() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2022{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectAugust2022MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectAugust2022MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremAugust2022MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectAugust2022SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectAugust2022SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremAugust2022SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectIunie2022MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectIunie2022MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremIunie2022MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectIunie2022SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectIunie2022SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremIunie2022SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectSpeciala2022MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2022/BaremSpeciala2022MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectSimulare2022MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectSimulare2022MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremSimulare2022MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectSimulare2022SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectSimulare2022SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremSimulare2022SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectModel2022MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectModel2022MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremModel2022MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2022/SubiectModel2022SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2022/SubiectModel2022SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2022/BaremModel2022SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}